<template>
  <div :class="$style.record">
    <div :class="$style.title">
      <i class="iconfont yw-xiangzuo" @click="back"></i>
      <span>充值记录</span>
    </div>
    <ul>
      <li>
        <span>商品名称</span>
        <span>充值价格</span>
        <span>充值时间</span>
      </li>
      <li v-for="(item, index) in recordList" :key="index">
        <span>{{ item.goods_name }}</span>
        <span>{{ item.money }}</span>
        <span>{{ item.update_time }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { orderList } from '@/api/pay'

export default {
  name: "",
  data() {
    return {
      recordList: [],
    };
  },
  mounted() {
    this.getOrderList()
  },
  computed: {
    ...mapState({
      bindRoleInfo: state => state.offlinePay.bindRoleInfo,
      appkey: state => state.offlinePay.appkey,
    })
  },
  methods: {
    ...mapMutations({
      setOfflinePayState: 'offlinePay/setState'
    }),
    back() {
      this.setOfflinePayState({ recordVisible: false })
    },
    async getOrderList() {
      const r = await orderList({
        user_id: this.bindRoleInfo.user_id,
        appkey: this.appkey
      })
      this.recordList = r.content
    }
  }
};
</script>

<style lang="scss" module>
.record {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  z-index: 10;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    font-size: 21px;
    width: 100%;
    position: relative;
    border-bottom: 1px solid #f4f4f4;
    :global {
      .iconfont {
        position: absolute;
        left: 10px;
        font-size: 20px;
        color: #666666;
      }
    }
  }
  > ul {
    > li {
      color: #999999;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 34px;
      border-bottom: 1px solid #F4F4F4;
      > span {
        width: 33.3%;
        text-align: center;
      }
    }
    > li:nth-child(1) {
      color: #666666;
      font-weight: 500;
      font-size: 16px;
    }
  }
}
</style>